<template>
	<div class="chat-messages-box">
		<div @scroll="onScroll" ref="messagesScroll" class="chat-messages-scroll">
			<MessagesList
				@resize.native="scrollIfNeeded"
				@pasteText="pasteTextToInput"
				@reset="scrollToEnd"
				@update="scrollIfNeeded"/>
			<div class="chat-typing" v-show="state.settings.typing" v-text="typingList"></div>
		</div>
		<AutocompletePopup ref="autocomplete" @applyCompletion="applyCompletion"/>
		<div class="chat-message-form">
			<MessageInput
				ref="messageInput"
				v-model="state.messageText"
				@input="onTyping"
				@resize="scrollIfNeeded"
				@send="sendMessage"/>
			<div @click="sendMessage" class="chat-button-send" title="Отправить">
				<div style="height: 100%; display: inline-block; vertical-align: middle;">
				</div><img src="/assets/i/send.svg" width="32" height="32">
			</div>
		</div>
	</div>
</template>

<script>
import MessagesList from './MessagesList.vue';
import AutocompletePopup from './AutocompletePopup.vue';
import MessageInput from './MessageInput.vue';
import eventBus from '../eventbus';
import Settings from '../src/settings';
import Autocomplete from '@chat/src/lib/autocomplete';

export default {
	components: {
		MessagesList,
		AutocompletePopup,
		MessageInput,
	},

	data(){
		return {
			state: eventBus.state,
			// autocompletion: non-managed-object,
		};
	},

	computed: {
		typingList(){
			let list = this.state.typingList;
			if (!Settings.typing || list.length == 0){
				return '';
			}
			return list.map(x => x.name).join(', ') + (list.length > 1 ? ' печатают...' : ' печатает...');
		},
	},

	methods: {
		onScroll(){
			this.state.isScrolledEnd = this.isNeedScrollToEnd();
		},

		onTyping(){
			eventBus.$emit('typing', true);
		},

		scrollIfNeeded(){
			if (this.state.isScrolledEnd){
				this.scrollToEnd();
			}
		},

		isNeedScrollToEnd(){
			let chat = this.$refs.messagesScroll;
			if (chat.scrollHeight - chat.clientHeight - chat.scrollTop < 5){
				return true;
			}

			return false;
		},

		scrollToEnd(){
			let chat = this.$refs.messagesScroll;
			chat.scrollTop = chat.scrollHeight;
		},

		sendMessage(){
			eventBus.$emit('sendMessage', this.state.messageText);
		},

		pasteTextToInput(text){
			this.$refs.messageInput.paste(text);
		},

		applyCompletion(item){
			this.autocompletion.applyCompletion(item);
		},
	},

	mounted(){
		this.autocompletion = new Autocomplete(this.$refs.messageInput.getInputElement(), {
			ui: this.$refs.autocomplete,
			completions: this.$refs.autocomplete.completions.bind(this.autocompleteForm),
		});

		this.$refs.messageInput.autocompletion = this.autocompletion;
	},
}
</script>

<style lang="less" scoped>
@import (reference) "~@/css/chat.less";

.chat-messages-box {
	background-color: @color-chat-2;
	padding: 8px;
}

.chat-messages-scroll {
	flex: auto;
	overflow: auto;
	word-wrap: break-word;

	.chat-typing {
		color: lightgray;
		font-style: italic;
		padding-left: 10px;
		min-height: 20px;
	}
}

.chat-message-form {
	flex: none;
	padding: 0;
	background-color: @color-chat-3;
	margin-top: 5px;
	border-radius: 5px;

	display: flex;
	flex-flow: row;
	align-items: center;

	.chat-input-message {
		flex: auto;
		width: 100%;
	}

	table.chat-inputs {
		width: 100%;
		height: 100%;
	}

	.chat-button-send {
		flex: none;
		min-width: 50px;
		cursor: pointer;
		text-align: center;
		font-size: 25px;
		height: 100%;

		img {
			vertical-align: middle;
		}
	}
}
</style>
